import React from 'react';
import styled from "styled-components";
import { Moment } from "moment";
import { Checkbox } from "../../../atoms/Checkbox";
import { useDispatch, useSelector } from "react-redux";
import {
  openRepeatWhereaboutsDialog,
  selectUserRequiredParking,
  setUserRequiresParking,
  updateMovement
} from '@features/whereabouts/store/editMovements.duck';
import { selectIsCarParkingEnabled, selectIsRepeatWeeklyScheduleEnabled } from '@shared/store/config.duck';
import { UNKNOWN_OPTION } from '@features/whereabouts/services/WhereaboutOptions';
import { BorderlessButton } from "../../../atoms/buttons/BorderlessButton";
import { IconTypes } from "../../../atoms/icon/Icon";
import { SecondaryButton } from "../../../atoms/buttons/SecondaryButton";
import Colours from "../../../atoms/Colours";

export function AdditionalWhereaboutsOptions(props: Props) {
  const dispatch = useDispatch();
  const userRequiresParking = useSelector(selectUserRequiredParking);
  const isCarParkingEnabled = useSelector(selectIsCarParkingEnabled);
  const isRepeatScheduleEnabled = useSelector(selectIsRepeatWeeklyScheduleEnabled);

  const clearWhereabouts = () => {
    dispatch(updateMovement({selectedOption: UNKNOWN_OPTION, locationId: 0, stickOnDay: true}));
  }

  const onRequireParkingSpaceCheckboxChanged = (val: boolean) => {
    dispatch(setUserRequiresParking(val));
  }

  const openRepeatWhereaboutsDialogViaEditWhereaboutsDuck = () => {
    dispatch(openRepeatWhereaboutsDialog());
  }

  return (
    <Wrapper>
      {isCarParkingEnabled && <>
        <Checkbox value={userRequiresParking}
                  className={"editWhereabouts__carParking--mobile"}
                  onChange={onRequireParkingSpaceCheckboxChanged}
                  text={'whereabouts.require-parking-space'} />
      </>}
      <BorderlessButton className="editWhereabouts__clearBtn--mobile"
                        icon={IconTypes.Bin}
                        text="button.clear-day"
                        click={clearWhereabouts}/>
      {isRepeatScheduleEnabled && <>
        <SecondaryButton click={openRepeatWhereaboutsDialogViaEditWhereaboutsDuck}
                         icon={IconTypes.Redo}
                         className={"editWhereabouts__repeatWhereabouts--mobile"}
                         text={'whereabouts.require-weekly-schedule'} />
      </>}
    </Wrapper>
  )
}

interface Props {
  activeDay?: Moment;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 36px auto 0 auto;
  .editWhereabouts__carParking--mobile {
    margin-bottom: 16px;
    p {
      color: ${Colours.darkGrey};
    }
  }
  .editWhereabouts__clearBtn--mobile {
    margin-bottom: 16px;
    background-color: ${Colours.veryLightGrey};
    color: ${Colours.darkGrey};
    span {
      margin: 0 !important;
    }
  }
  .editWhereabouts__repeatWhereabouts--mobile {
    margin-bottom: 16px;
  }
`
